import styled, { keyframes } from "styled-components";

export const AppointmentContainer = styled.div`
  text-align: center;
  max-width: 880px;
  margin: 60px auto 40px;
  padding: 0 var(--container-pad);

  @media (max-width: 600px) {
    margin-top: 40px;
  }
`;

export const AppointmentWrapper = styled.div`
  background: white;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  padding: 44px 48px;
  box-shadow: var(--shadow-sm);
  text-align: left;

  @media (max-width: 600px) {
    padding: 28px 22px;
  }
`;

export const HeadText = styled.p`
  font-size: clamp(22px, 3vw, 30px);
  font-weight: 800;
  color: var(--color-primary);
  line-height: 1.3;
  letter-spacing: -0.5px;
  margin: 0 0 22px;
  text-align: center;
`;

export const MainText = styled.p`
  text-align: left;
  font-size: 16px;
  line-height: 1.6;
  color: var(--color-text);
  margin: 8px 0;
`;

export const MainForm = styled.form`
  text-align: left;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    font-weight: 600;
    font-size: 14px;
    color: var(--color-text-muted);
    margin-top: 16px;
  }
`;

export const MainInput = styled.input`
    display: block;
    margin-top: 8px;
    width: 100%;
    padding: 12px 14px;
    font-size: 15px;
    font-family: inherit;
    border: 1.5px solid var(--color-border);
    border-radius: var(--radius-md);
    outline: none;
    transition: var(--transition);
    background: white;

    &:focus {
        border-color: var(--color-primary);
        box-shadow: 0 0 0 4px var(--color-primary-soft);
    }
`;

export const LableAppointmentContainer = styled.label`
    width: 100%;
    max-width: 600px;
`;

export const SelectAppointmentContainer = styled.select`
    width: 100%;
    padding: 12px 44px 12px 16px;
    font-size: 15px;
    font-family: inherit;
    font-weight: 500;
    color: var(--color-text);
    border: 1.5px solid var(--color-border);
    border-radius: var(--radius-md);
    text-align: left;
    background-color: white;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='14' height='8' viewBox='0 0 14 8' fill='none'%3e%3cpath d='M1 1L7 7L13 1' stroke='%235b8b0f' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 16px center;
    background-size: 14px 8px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    outline: none;
    cursor: pointer;
    margin-top: 8px;
    transition: var(--transition), background-image 0ms;

    &:hover {
        border-color: var(--color-primary-light);
    }

    &:focus {
        border-color: var(--color-primary);
        box-shadow: 0 0 0 4px var(--color-primary-soft);
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='14' height='8' viewBox='0 0 14 8' fill='none'%3e%3cpath d='M1 7L7 1L13 7' stroke='%235b8b0f' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e");
    }

    option {
        font-weight: 500;
        color: var(--color-text);
        padding: 10px;
    }
`;

export const AppointmentButton = styled.button`
  background: var(--color-primary);
  padding: 14px 36px;
  border-radius: var(--radius-md);
  border: none;
  cursor: pointer;
  color: white;
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0.4px;
  font-family: inherit;
  display: block;
  margin-top: 24px;
  box-shadow: 0 8px 18px rgba(91, 139, 15, 0.28);
  transition: var(--transition);

  &:hover {
    background: var(--color-primary-dark);
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(91, 139, 15, 0.36);
  }
`;

export const BlueSpan = styled.span`
    color: #0a4eb0;
    font-weight: 700;
`;

export const GreenSpan = styled.span`
    color: var(--color-primary);
    font-weight: 700;
    cursor: pointer;
`;

export const ErrorText = styled.p`
    color: #d33636;
    font-size: 13px;
    text-align: left;
    margin: 6px 0 0;
    line-height: 1.4;
`;

export const SuccessText = styled.p`
    color: var(--color-primary);
    font-size: 14px;
    font-weight: 600;
    text-align: left;
    margin: 14px 0 0;
    line-height: 1.4;
`;

const popIn = keyframes`
  0% { transform: scale(0.6); opacity: 0; }
  60% { transform: scale(1.08); opacity: 1; }
  100% { transform: scale(1); opacity: 1; }
`;

const drawCheck = keyframes`
  to { stroke-dashoffset: 0; }
`;

const ringPulse = keyframes`
  0% { transform: scale(1); opacity: 0.45; }
  100% { transform: scale(1.6); opacity: 0; }
`;

export const SuccessCard = styled.div`
    margin-top: 28px;
    background: linear-gradient(160deg, var(--color-primary-soft) 0%, rgba(255, 255, 255, 0.6) 100%);
    border: 1px solid var(--color-primary-light);
    border-radius: var(--radius-xl);
    padding: 40px 36px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
    animation: ${popIn} 360ms cubic-bezier(0.34, 1.56, 0.64, 1);

    @media (max-width: 600px) {
        padding: 32px 22px;
    }
`;

export const SuccessIconWrap = styled.div`
    position: relative;
    width: 76px;
    height: 76px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color-primary);
    border-radius: 50%;
    box-shadow: 0 12px 28px rgba(91, 139, 15, 0.32);

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        border-radius: 50%;
        background: var(--color-primary);
        animation: ${ringPulse} 1.6s ease-out infinite;
        z-index: 0;
    }

    svg {
        position: relative;
        z-index: 1;
        width: 36px;
        height: 36px;
        color: white;
    }

    svg path {
        stroke-dasharray: 28;
        stroke-dashoffset: 28;
        animation: ${drawCheck} 420ms 200ms ease-out forwards;
    }
`;

export const SuccessTitle = styled.h3`
    margin: 0;
    font-size: clamp(22px, 2.6vw, 28px);
    font-weight: 800;
    color: var(--color-primary-dark);
    letter-spacing: -0.3px;
`;

export const SuccessDescription = styled.p`
    margin: 0;
    max-width: 460px;
    font-size: 15px;
    line-height: 1.6;
    color: var(--color-text);
`;

export const SuccessButton = styled.button`
    margin-top: 8px;
    background: white;
    border: 1.5px solid var(--color-primary);
    color: var(--color-primary);
    padding: 12px 26px;
    font-family: inherit;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.4px;
    border-radius: var(--radius-md);
    cursor: pointer;
    transition: var(--transition);

    &:hover {
        background: var(--color-primary);
        color: white;
        box-shadow: 0 10px 22px rgba(91, 139, 15, 0.28);
        transform: translateY(-2px);
    }
`;
